const {
  PARAM_STR,
  PARAM_DEX,
  PARAM_CON,
  PARAM_INT,
  PARAM_WIT,
  PARAM_CHA,
} = require('./../../../../paramList')
const {
  SPEED_FLY,
  SPEED_WALK,
} = require('./../../../../speedList')
const {ATTACK_MELEE_WEAPON} = require('./../../../../attackTypeList')
const {ALIGNMENT_NO} = require('./../../../../aligmentList')
const {CR_1_2} = require('./../../../../crList')
const {CREATURE_COCKATRICE} = require('./../../../../creatureIdList')
const {CREATURE_TYPE_MONSTROSITY} = require('./../../../../creatureTypeIdList')
const {DAMAGE_PIERCING} = require('./../../../../damageTypeList')
const {GENDER_MALE} = require('./../../../../genderList')
const {SENSE_DARK_VISION} = require('./../../../../senseList')
const {SIZE_TINY} = require('./../../../../sizeList')
const {SOURCE_MM} = require('./../../../../sourceList')
const {TARGET_CREATURE} = require('./../../../../targetList')

module.exports = {
  name: 'Куролиск',
  nameEn: 'Cockatrice',
  description: `Куролиск выглядят как отвратительная помесь ящерицы, птицы и летучей мыши, и они печально известны своей способностью превращать плоть в камень. Рацион этих всеядных существ включает в себя ягоды, орехи и цветы, а также небольших живых существ, вроде насекомых, мышей и лягушек — таких, которых они могут проглотить целиком.

Они не представляли бы собой угрозу, если бы не их яростная и бешеная реакция при малейшем намёке на опасность. Куролиск летит навстречу любой угрозе, пронзительно кричит и бешено машет крыльями, в то же время, нанося стремительные удары клювом. Малейшая царапина, нанесённая куролиском, может стать роковой, так как его жертва медленно превращается в камень из-за полученного урона.`,
  id: CREATURE_COCKATRICE,
  sizeType: SIZE_TINY,
  creatureTypeIdList: [
    CREATURE_TYPE_MONSTROSITY,
  ],
  alignmentId: ALIGNMENT_NO,
  source: {
    id: SOURCE_MM,
    page: 186,
  },
  armor: 11,
  hp: {
    diceCount: 6,
  },
  speed: {
    [SPEED_WALK]: 20,
    [SPEED_FLY]: 40,
  },
  params: {
    [PARAM_STR]: 6,
    [PARAM_DEX]: 12,
    [PARAM_CON]: 12,
    [PARAM_INT]: 2,
    [PARAM_WIT]: 13,
    [PARAM_CHA]: 5,
  },
  senseList: [
    {
      id: SENSE_DARK_VISION,
      value: 60,
    },
  ],
  cr: CR_1_2,
  actionList: [
    {
      name: 'Укус',
      description: `Цель должна пройти испытание Телосложения СЛ 11, чтобы не превратиться магическим образом в камень. При провале существо начинает превращаться в камень и обездвиживается. Оно должно повторить это испытание в конце своего следующего хода. При успехе эффект заканчивается. При провале существо становится окаменевшим на 24 часа.`,
      attack: {
        type: ATTACK_MELEE_WEAPON,
        bonus: 3,
        range: 5,
        target: {
          count: 1,
          limit: {
            type: TARGET_CREATURE,
          },
        },
        hit: {
          type: DAMAGE_PIERCING,
          diceCount: 1,
          diceType: 4,
          diceBonus: 1,
        },
      },
    },
  ],
  genderId: GENDER_MALE,
}
